import { Button, Modal } from "flowbite-react";

export default function ModalComp({
  tittle,
  acceptTittle,
  declineTittle,
  children,
  size = "7xl",
  openModal,
  setOpenModal,
}) {
  return (
    <>
      <Modal show={openModal} size={size} onClose={() => setOpenModal(false)}>
        <Modal.Header>{tittle}</Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={() => setOpenModal(false)}>{acceptTittle}</Button> */}
          <Button color="gray" onClick={() => setOpenModal(false)}>
            {declineTittle}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
